export const MAP_NS = 'yandexPilki'
